











































import { Component, Prop, Vue } from 'vue-property-decorator';
import redirectToLocation from '@/commons/redirectManager';
import user from '@/store/modules/user';
import Logo from '@/components/UI/Logo.vue';
import CheckoutSteps from '@/components/Checkout/Steps.vue';
import cart from '@/store/modules/cart';
import device from '@/store/modules/device';
import BackButton from '@/components/UI/BackButton.vue';

@Component({
    components: {
        Logo,
        CheckoutSteps,
        BackButton,
    },
})
export default class CartHeader extends Vue {
    @Prop({ default: true }) public showCheckoutBackButton!: boolean;
    @Prop() private title!: string;

    get isLogged(): boolean {
        return user.isLoggedin;
    }

    get isCart() {
        return this.step === 'cart' || typeof this.step === 'undefined';
    }

    get step() {
        return this.$route.params.step;
    }

    get isMobile() {
        return device.isMobile;
    }

    private redirectToHome() {
        redirectToLocation('/');
    }

    private stepBack() {
        const currentStep = this.step;

        switch (currentStep) {
            case 'login':
                this.$router.push({ path: '/' });
                break;
            case 'shipping':
                if (this.isLogged) {
                    this.$router.push({ path: '/' });
                } else {
                    this.$router.push({ path: '/checkout/login' });
                }
                break;
            case 'invoice':
                if (cart.isVirtual) {
                    this.$router.push({ path: '/' });
                } else {
                    this.$router.push({ path: '/checkout/shipping' });
                }

                break;
            default:
                break;
        }
    }

    private mounted() {
        device.updateMobileDetection();
    }

    private created() {
        device.detectMobile();
    }
}
